var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-avatar',_vm._b({attrs:{"left":"","color":_vm.color}},'v-avatar',_vm.$attrs,false),[_vm._v(_vm._s(_vm._f("literal")(_vm.value.name)))])}
var staticRenderFns = []

export { render, staticRenderFns }